import React from 'react';
import { Link } from 'react-router-dom';
import { SendIcon, PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const categoryLinks = [{
    to: '/category/basejny',
    label: 'Басейни'
  }, {
    to: '/category/dzhakuzi-ta-kryzhanni-vany',
    label: 'Джакузі та крижанні вани'
  }, {
    to: '/category/khimiya-dlya-basejnu',
    label: 'Хімія для басейну'
  }, {
    to: '/category/obladnannya-dlya-basejnu',
    label: 'Обладнання для басейну'
  }, {
    to: '/category/nakryttya-dlya-basejnu',
    label: 'Накриття для басейну'
  }, {
    to: '/category/aksesuary-dlya-basejnu',
    label: 'Аксесуари для басейну'
  }];
  const infoLinks = [{
    to: '/delivery',
    label: 'Доставка та оплата'
  }, {
    to: '/warranty',
    label: 'Гарантія та повернення'
  }, {
    to: '/installation',
    label: 'Монтаж та сервіс'
  }, {
    to: '/about',
    label: 'Про компанію'
  }, {
    to: '/contacts',
    label: 'Контакти'
  }, {
    to: '/faq',
    label: 'FAQ'
  }, {
    to: '/blog',
    label: 'Блог'
  }];
  return <footer className="bg-white border-t border-slate-200" data-id="element-128">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16" data-id="element-129">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12" data-id="element-130">
          {/* Brand Column */}
          <div data-id="element-131">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-132">
              <div className="w-10 h-10 bg-gradient-to-br from-sky-400 to-cyan-500 rounded-xl flex items-center justify-center" data-id="element-133">
                <span className="text-white font-bold text-lg" data-id="element-134">A</span>
              </div>
              <span className="text-xl font-bold text-slate-900" data-id="element-135">
                Aqua Pools
              </span>
            </Link>
            <p className="text-sm text-slate-600 mb-6 leading-relaxed" data-id="element-136">
              Басейни та обладнання для чистої води та комфорту. Підбір,
              доставка та сервіс в Івано-Франківську та по всій Україні.
            </p>
            <a href="https://t.me/aquapools_if" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2.5 bg-sky-500 text-white rounded-xl font-medium hover:bg-sky-600 transition-colors" data-id="element-137">
              <SendIcon className="w-5 h-5" data-id="element-138" />
              Написати в Telegram
            </a>
          </div>

          {/* Categories Column */}
          <div data-id="element-139">
            <h3 className="text-slate-900 font-semibold mb-4" data-id="element-140">Категорії</h3>
            <ul className="space-y-2.5" data-id="element-141">
              {categoryLinks.map(link => <li key={link.to} data-id="element-142">
                  <Link to={link.to} className="text-sm text-slate-600 hover:text-slate-900 transition-colors" data-id="element-143">
                    {link.label}
                  </Link>
                </li>)}
              <li data-id="element-144">
                <Link to="/catalog" className="text-sm text-sky-600 hover:text-sky-700 transition-colors font-medium" data-id="element-145">
                  Всі категорії →
                </Link>
              </li>
            </ul>
          </div>

          {/* Info Column */}
          <div data-id="element-146">
            <h3 className="text-slate-900 font-semibold mb-4" data-id="element-147">Інформація</h3>
            <ul className="space-y-2.5" data-id="element-148">
              {infoLinks.map(link => <li key={link.to} data-id="element-149">
                  <Link to={link.to} className="text-sm text-slate-600 hover:text-slate-900 transition-colors" data-id="element-150">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contacts Column */}
          <div data-id="element-151">
            <h3 className="text-slate-900 font-semibold mb-4" data-id="element-152">Контакти</h3>
            <ul className="space-y-4" data-id="element-153">
              <li data-id="element-154">
                <a href="tel:+380671234567" className="flex items-center gap-3 text-sm text-slate-600 hover:text-slate-900 transition-colors" data-id="element-155">
                  <PhoneIcon className="w-5 h-5 text-sky-500 flex-shrink-0" data-id="element-156" />
                  +38 (067) 123-45-67
                </a>
              </li>
              <li data-id="element-157">
                <a href="mailto:sales@aquapools.ua" className="flex items-center gap-3 text-sm text-slate-600 hover:text-slate-900 transition-colors" data-id="element-158">
                  <MailIcon className="w-5 h-5 text-sky-500 flex-shrink-0" data-id="element-159" />
                  sales@aquapools.ua
                </a>
              </li>
              <li data-id="element-160">
                <a href="https://t.me/aquapools_if" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-slate-600 hover:text-slate-900 transition-colors" data-id="element-161">
                  <SendIcon className="w-5 h-5 text-sky-500 flex-shrink-0" data-id="element-162" />
                  @aquapools_if
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-slate-600" data-id="element-163">
                <MapPinIcon className="w-5 h-5 text-sky-500 flex-shrink-0 mt-0.5" data-id="element-164" />
                <span data-id="element-165">м. Івано-Франківськ, Україна</span>
              </li>
            </ul>

            <div className="mt-6 pt-6 border-t border-slate-200" data-id="element-166">
              <p className="text-xs text-slate-500" data-id="element-167">Графік роботи:</p>
              <p className="text-sm text-slate-600 mt-1" data-id="element-168">Пн-Пт: 9:00 - 18:00</p>
              <p className="text-sm text-slate-600" data-id="element-169">Сб: 10:00 - 15:00</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-200 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-170">
          <p className="text-sm text-slate-500" data-id="element-171">
            © {currentYear} Aqua Pools. Всі права захищені.
          </p>
          <div className="flex items-center gap-6" data-id="element-172">
            <Link to="/privacy" className="text-sm text-slate-500 hover:text-slate-700 transition-colors" data-id="element-173">
              Політика конфіденційності
            </Link>
            <Link to="/terms" className="text-sm text-slate-500 hover:text-slate-700 transition-colors" data-id="element-174">
              Умови використання
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}